import { create } from 'zustand';

export type ThemeId =
  | 'classic'
  | 'aidd'
  | 'aidd-dark'
  | 'ultra'
  | 'mayakovsky';

interface ThemeInfo {
  id: ThemeId;
  accent: string;
}

export const THEMES: ThemeInfo[] = [
  { id: 'classic', accent: '#2563eb' },
  { id: 'aidd', accent: '#ff5a00' },
  { id: 'aidd-dark', accent: '#ff5a00' },
  { id: 'ultra', accent: '#6c3aed' },
  { id: 'mayakovsky', accent: '#d92020' },
];

const THEME_IDS: ThemeId[] = THEMES.map((t) => t.id);

/** Тёмный сайдбар (тёмные темы). Светлые темы используют светлую панель. */
export function isDarkChromeTheme(id: ThemeId): boolean {
  return id === 'aidd-dark' || id === 'ultra';
}

function getStoredTheme(): ThemeId {
  try {
    const saved = localStorage.getItem('lk-theme') as ThemeId | null;
    if (saved && THEME_IDS.includes(saved)) {
      return saved;
    }
  } catch { /* SSR-safe */ }
  return 'classic';
}

function applyTheme(id: ThemeId) {
  document.documentElement.setAttribute('data-theme', id);
  localStorage.setItem('lk-theme', id);
}

interface ThemeState {
  theme: ThemeId;
  setTheme: (id: ThemeId) => void;
}

const initialTheme = getStoredTheme();
applyTheme(initialTheme);

export const useThemeStore = create<ThemeState>((set) => ({
  theme: initialTheme,
  setTheme: (id) => {
    applyTheme(id);
    set({ theme: id });
  },
}));
